import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { recordingsSelectors as nucleusRecordingsSelectors, currentUserSelectors, featureSelectors } from '@lifesize/nucleus';
import { FEATURE_FLAG_UPLOAD_RECORDING } from 'constants/featureFlags';
import Recordings from 'components/Recordings/RecordingsTab/RecordingsTab';
import { RecordingRequestObjectFeed, RecordingLimits } from 'constants/recordingsConstants';
import actions from 'actions/recordingsActions';
import { actions as ModalActions } from 'actions/modalActions';
import { ModalTypes } from 'constants/modalConstants';
import * as RS from 'selectors/recordingsSelectors';
import { Global } from 'state/Global';
import { isAdminOrSuperUser } from 'utils/userProfileUtils';
import _get from 'lodash/get';
import { defaultProps } from 'recompose';
import { UploadRecordingStatus } from 'constants/recordingsConstants';

const viewerCanUpload = createSelector(
  currentUserSelectors.myInfo,
  featureSelectors.getFeatureFlags,
  (currentUser, featureFlags) => isAdminOrSuperUser(currentUser) && _get(featureFlags, FEATURE_FLAG_UPLOAD_RECORDING)
);

export interface OwnPropsInterface {
  pageType: RecordingRequestObjectFeed;
}

const mapStateToProps = (state: Global, ownProps: OwnPropsInterface) => {
  const recordingsFeedState = nucleusRecordingsSelectors.recordingsFeed(state);
  const isGridLayout = RS.selectIsGridLayout(state);
  const canUpload = viewerCanUpload(state) && ownProps.pageType === RecordingRequestObjectFeed.FEED_ALL;
  return {
    isGridLayout: isGridLayout,
    isLoading: _get(recordingsFeedState, 'isFetching'),
    limit: RecordingLimits.PAGE_SIZE,
    pageType: ownProps.pageType,
    recordingData: _get(recordingsFeedState, 'data'),
    totalCount: _get(recordingsFeedState, 'count'),
    error: _get(recordingsFeedState, 'error'),
    canUpload,
    processingUploadCount: RS.getUploadsStatus(state).filter(upload => [UploadRecordingStatus.PROCESSING].includes(upload.status)).length
  };
};

const mapDispatchToProps = (dispatch: Function, ownProps: OwnPropsInterface) => ({
  handleFetchFeedData: () => {
    dispatch(actions.setRecordingSearchId());
    dispatch(actions.handleLoadRecords(ownProps.pageType));
  },
  handlePageChange: (pageNum: number) => {
    dispatch(actions.handlePageChange(pageNum));
    dispatch(actions.handleLoadRecords(ownProps.pageType));
  },
  handleResetRecordingProps: () => {
    dispatch(actions.handleResetRecordingProps());
  },
  openUpload: () => {
    dispatch(ModalActions.openModal({ modalType: ModalTypes.UPLOAD_RECORDING }));
  },
  getUploadsStatus: () => dispatch(actions.getUploadsStatus())
});

const RecordingsContainer = connect(mapStateToProps, mapDispatchToProps)(Recordings);

export const RecordingsFeedWithFeedAll =
  defaultProps({pageType: RecordingRequestObjectFeed.FEED_ALL})(RecordingsContainer);
export const RecordingsFeedWithMyRecordings =
  defaultProps({pageType: RecordingRequestObjectFeed.FEED_MY_RECORDINGS})(RecordingsContainer);
export const RecordingsFeedWithWatchLater =
  defaultProps({pageType: RecordingRequestObjectFeed.FEED_WATCH_LATER})(RecordingsContainer);
